import { Box, Grid } from "@mui/material";

export default function ResponsiveLayout({ catalog, cart, mobileCartTrigger }) {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8} sx={{ minWidth: 0 }}>
          {catalog}
        </Grid>
        <Grid
          item
          md={4}
          sx={{
            display: { xs: "none", md: "block" },
            minWidth: 0,
          }}
        >
          {cart}
        </Grid>
      </Grid>
      {mobileCartTrigger}
    </Box>
  );
}
